import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SignInFeatureHero } from "../hero/SignInFeatureHero";

type Props = {
  children: ReactNode;
};

export function SignInSplitLayout({ children }: Props) {
  return (
    <div className="signin-split">
      <section className="signin-split-left">
        <Link
          to="/"
          className="signin-split-wordmark"
          aria-label="Noah's Farm home"
        >
          <span className="signin-split-wordmark-icon" aria-hidden>
            <img src="/logo-horizontal.png" alt="" />
          </span>
        </Link>

        <div className="signin-split-form-wrap">
          <div className="signin-form-stack">
            <h1 className="signin-headline signin-split-headline">
              Log in to
              <br />
              access N-OS
            </h1>
            <p className="signin-subhead">
              Your AI-powered flavor discovery platform
            </p>
            {children}
          </div>
        </div>

        <div className="signin-split-footer">
          <div className="signin-split-signup">
            Don't have an account yet?{" "}
            <a href="#">Contact us for a free trial</a>
          </div>
          <div className="signin-split-terms">
            By continuing, you agree to Noah's Farm{" "}
            <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
          </div>
        </div>
      </section>

      <SignInFeatureHero />
    </div>
  );
}
